<div *ngIf="showreAllocateView && !hideAllocateView">
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Re-Allocation</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- <div>{{msg}}</div> -->

  <div class="modal-body customModalBody">

    <div class="form-group">
      <label>Select Reason</label>
     <select id="reAllocateReason" class="form-control col-form-label-sm" [(ngModel)]="reasonType">
                <option [ngValue]="null" disabled>Select</option>
                <option *ngFor="let reasonOption of reasonOptions" [value]="reasonOption.value">{{
                  reasonOption.label }}</option>
     </select>
    </div>
    <div class="form-group" >
      <label>Select Associate</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="assocType" (change)="getSubBranches($event.target.value)">
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let assoc_data of isAssocData" value={{assoc_data.assoc_code}}>
          {{assoc_data.assoc_name}}

        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="issubCategory">
      <label>Select Branch</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="branchType" (change)="getofficersList()">
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let branch_info of branchInfo" value={{branch_info.branch_id}}>
          {{branch_info.branch_name}}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="isTableView">
        <table class="table">
        <thead>
            <tr>
            <th scope="col">#</th>
            <th scope="col">Officer Name</th>
            <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let officer_list of officerList;let i = index">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{officer_list.officer_name}}</td>
            <td>
                <button type="button" class="btn green_btn pull-right" (click)="forceAllocation(officer_list.officer_id,officer_list.officer_name,isSendStatus)" [disabled]="officer_list.disabled">Select</button>
            </td>
            </tr>
        </tbody>
        </table>
    </div>

  </div>
</div>

<div *ngIf="showAllocateView && !hideAllocateView">
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Allocation</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- <div>{{msg}}</div> -->

  <div class="modal-body customModalBody">
    <div class="form-group" *ngIf="orderDetailsRes.order.patientinfo.service_type !== '5' && orderDetailsRes.order.patientinfo.service_type !== '6' && orderDetailsRes.order.patientinfo.service_type !== '7' && orderDetailsRes.order.patientinfo.service_type !== '8'">
      <label>Select Associate</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="assocType" (change)="getSubBranches($event.target.value)">
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let assoc_data of isAssocData" value={{assoc_data.assoc_code}}>
          {{assoc_data.assoc_name}}

        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="issubCategory">
      <label>Select Branch</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="branchType" (change)="getofficersList()">
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let branch_info of branchInfo" value={{branch_info.branch_id}}>
          {{branch_info.branch_name}}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="isTableView">
        <table class="table">
        <thead>
            <tr>
            <th scope="col">#</th>
            <th scope="col">Officer Name</th>
            <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let officer_list of officerList;let i = index">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{officer_list.officer_name}}</td>
            <td>
                <button type="button" class="btn green_btn pull-right" (click)="forceAllocation(officer_list.officer_id,officer_list.officer_name,isSendStatus)" [disabled]="officer_list.disabled">Select</button>
            </td>
            </tr>
        </tbody>
        </table>
    </div>

  </div>
</div>

<div *ngIf="hideAllocateView && !showReportsCompletedView && (isSendStatus != 'forceAllocate')">
  <div class="modal-header customBlueHeader">
    <p class="modal-title" *ngIf="showreAllocateView">Re-Allocation</p>
    <p class="modal-title" *ngIf="showAllocateView">Allocation</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- <div>{{msg}}</div> -->

  <div class="modal-body customModalBody">

    <div class="form-group">
      <!--<label>Select Reason</label>
     <select id="reAllocateReason" class="form-control col-form-label-sm" [(ngModel)]="reasonType">
                <option [ngValue]="null" disabled>Select</option>
                <option *ngFor="let reasonOption of reasonOptions" [value]="reasonOption.value">{{
                  reasonOption.label }}</option>
     </select>-->
    </div>
    <div class="form-group" >
      <h6 style="color:red;">Officer are not availble to Allocation !!</h6>
    </div>

  </div>
</div>

<div *ngIf="showReportsCompletedView && (isSendStatus != 'forceAllocate')">
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Are you sure all the reports for particular order generated.????</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-footer customModalFooter customModalFooter">
        <button type="submit" class="btn green_btn" (click)="reportComplete()">Yes</button>
        <button type="button" class="btn danger_btn" (click)="close()">No</button>
  </div>
</div>

<div *ngIf="isSendStatus == 'forceAllocate'">
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Force Allocate</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- <div>{{msg}}</div> -->

  <div class="modal-body customModalBody">

    <div class="form-group">
      <label for="formGroupExampleInput">Select Officer</label>
      <ng-select #ForceAllocationOfficers  [items]="ForceAllocationOffList" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
        (clear)="resetTeantFilters();" bindLabel="isp_name" bindValue="isp_code"
        placeholder="Select Officer" (change)="onTenantOrgSearch($event)">
        <ng-options *ngFor="let item of ForceAllocationOffList " [Value]="item.isp_code">{{item.isp_name}}
        </ng-options>
      </ng-select>
    </div>
    <div class="form-group">
      <label for="formGroupExampleInput">Remarks</label>
      <input class="form-control col-form-label-sm" type="text" [(ngModel)]="remarksForAllocation">
    </div>
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
      <button type="button" class="btn green_btn" (click)="submitForceAllocation()">Submit</button>
    </div>
    <!-- <div class="form-group" >
      <label>Select Associate</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="assocType" (change)="getSubBranches($event.target.value)">
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let assoc_data of isAssocData" value={{assoc_data.assoc_code}}>
          {{assoc_data.assoc_name}}

        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="issubCategory">
      <label>Select Branch</label>
      <select class="form-control col-form-label-sm" [(ngModel)]="branchType" (change)="getofficersList()">
        <option [ngValue]="null" disabled>Select</option>
        <option *ngFor="let branch_info of branchInfo" value={{branch_info.branch_id}}>
          {{branch_info.branch_name}}
        </option>
      </select>
    </div>

    <div class="form-group" *ngIf="isTableView">
        <table class="table">
        <thead>
            <tr>
            <th scope="col">#</th>
            <th scope="col">Officer Name</th>
            <th scope="col"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let officer_list of officerList;let i = index">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{officer_list.officer_name}}</td>
            <td>
                <button type="button" class="btn green_btn pull-right" (click)="forceAllocation(officer_list.officer_id,officer_list.officer_name,isSendStatus)" [disabled]="officer_list.disabled">Select</button>
            </td>
            </tr>
        </tbody>
        </table>
    </div> -->

  </div>
</div>

<div *ngIf="isSendStatus == 'createOfficer'">
  <div class="modal-header customBlueHeader">
    <p class="modal-title">Create Officer</p>
    <button type="button" class="close" aria-label="Close" (click)="modelClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <!-- <div>{{msg}}</div> -->

  <div class="modal-body customModalBody">

    <!-- <div class="form-group">
      <label for="formGroupExampleInput">Select Officer</label>
      <ng-select #ForceAllocationOfficers  [items]="ForceAllocationOffList" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
        (clear)="resetTeantFilters();" bindLabel="isp_name" bindValue="isp_code"
        placeholder="Select Officer" (change)="onTenantOrgSearch($event)">
        <ng-options *ngFor="let item of ForceAllocationOffList " [Value]="item.isp_code">{{item.isp_name}}
        </ng-options>
      </ng-select>
    </div> -->
    <!-- <div class="form-group">
      <label for="formGroupExampleInput">Remarks</label>
      <input class="form-control col-form-label-sm" type="text" [(ngModel)]="remarksForAllocation">
    </div> -->
    <form [formGroup]="staff_Form" >
      <div class="row">
          <div class="col-4">
              <div class="form-group">
                  <label for="hospital-name">Associates Name<span>*</span></label>
                  <ng-select   [items]="associatesList" [multiple]="false" [closeOnSelect]="true" [clearable]="true"
                  (clear)="resetLanguagesFilters();" bindLabel="firstName" bindValue="associateCode"
                  placeholder="Select Language" (change)="selectAssociateList($event)" formControlName="associateName">
                  <ng-options *ngFor="let item of associatesList " [Value]="item.associateCode">{{item.firstName
                  }}
                  </ng-options>
                </ng-select>
                  <div class="text-danger"*ngIf="(f['associateName'].touched || isSubmited ) && f['associateName'].errors" >
                      <div *ngIf="f['associateName'].errors['required']">Associates Name is required</div>
                  </div>
              </div>
          </div>
          <div class="col-4">
              <div class="form-group">
                  <label for="BranchName">Branch Name<span>*</span></label>
                  <!-- <input type="text" id="BranchName" class="form-control marT8"
                  formControlName="branchName"> -->
                  <select class="form-control form-select marT8"  
                  formControlName="branchName">
                      <option value="">Select Branch</option>
                      <option value={{branchData?.assocLocMapId}} *ngFor="let branchData of  branchList">
                          {{branchData?.address}}
                      </option>
                  </select>
                  <div class="text-danger"*ngIf="(f['branchName'].touched || isSubmited ) && f['branchName'].errors" >
                      <div *ngIf="f['branchName'].errors['required']">Branch Name is required</div>
                  </div>
              </div>
          </div>  
      </div>
      <div class="row" *ngIf="selecetdAssociateCode != null && staff_Form.value.branchName != '' ">
          <div class="col-4">
              <div class="form-group">
                  <label for="fname">First Name<span>*</span></label>
                  <input type="text" id="fname" class="form-control marT8"
                  formControlName="firstName">
                  <div class="text-danger"*ngIf="(f['firstName'].touched || isSubmited ) && f['firstName'].errors" >
                      <div *ngIf="f['firstName'].errors['required']">First Name is required</div>
                  </div>
              </div>
          </div>
          <div class="col-4">
              <div class="form-group">
                  <label for="lName">Last Name<span>*</span></label>
                  <input type="text" id="lName" class="form-control marT8"
                  formControlName="lastName">
                  <div class="text-danger"*ngIf="(f['lastName'].touched || isSubmited ) && f['lastName'].errors" >
                      <div *ngIf="f['lastName'].errors['required']">Last Name is required</div>
                  </div>
              </div>
          </div>
          <div class="col-4">
              <div class="form-group">
                  <label for="gender">Gender<span>*</span></label>
                  <select id="gender" class="form-control form-select marT8"
                  formControlName="gender">
                      <option value="0">Select</option>
                      <option value="2">Male</option>
                      <option value="1">Female</option>
                  </select>
                  <div class="text-danger"*ngIf="(f['gender'].touched || isSubmited ) && f['gender'].errors" >
                      <div *ngIf="f['gender'].errors['required']">Gender is required</div>
                  </div>
              </div>
          </div>
      <!-- </div>
      <div class="row"> -->
          <div class="col-4">
              <div class="form-group">
                  <label for="mobile">Mobile<span>*</span></label>
                  <input type="tell" id="mobile" class="form-control marT8"
                  formControlName="mobile">
                  <div class="text-danger"*ngIf="(f['mobile'].touched || isSubmited ) && f['mobile'].errors" >
                      <div *ngIf="f['mobile'].errors['required']">Mobile is required</div>
                      <div *ngIf="f['mobile'].errors['invalidMobileNumber']">Please enter the valid mobile Number</div>
                  </div>
              </div>
          </div>
          <div class="col-4">
              <div class="form-group">
                  <label for="email">Email Id<span>*</span></label>
                  <input type="email" id="email" class="form-control marT8"
                  formControlName="email">
                  <div class="text-danger"*ngIf="(f['email'].touched || isSubmited ) && f['email'].errors" >
                      <div *ngIf="f['email'].errors['required']">Email Id is required</div>
                      <div *ngIf="f['email'].errors['email']">Please enter the valid Email ID</div>
                  </div>
              </div>
          </div>
          <div class="col-4">
              <div class="form-group">
                  <label for="language">Language Spoken<span>*</span></label>
                  <ng-select #ForceAllocationOfficers  [items]="languagesList" [multiple]="true" [closeOnSelect]="true" [clearable]="true"
                    (clear)="resetLanguagesFilters();" bindLabel="name" bindValue="code"
                    placeholder="Select Language" (change)="selectLanguage($event)">
                    <ng-options *ngFor="let item of languagesList " [Value]="item.code">{{item.name}}
                    </ng-options>
                  </ng-select>            
                  <!-- <ng-multiselect-dropdown
                  formControlName="lanSpoken"
                  [settings]="dropdownSettings"
                  [data]="languagesList"
                  [(ngModel)]="selectedLanguagesList"
                  (onSelect)="onLanguagesSelection($event)"
                  (onDeSelect)="onLanguagesDeSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  (onDeSelectAll)="onDeSelectAll($event)">
                  </ng-multiselect-dropdown> -->
                  <div class="text-danger"*ngIf="(f['lanSpoken'].touched || isSubmited ) && f['lanSpoken'].errors" >
                      <div *ngIf="f['lanSpoken'].errors['required']">Language Spoken is required</div>
                  </div>
              </div>
          </div>
      <!-- </div>
      <div class="row"> -->
          <div class="col-4">
              <div class="form-group">
                  <label for="yoe">Years Of Experience<span>*</span></label>
                  <input type="text" id="yoe" class="form-control marT8"
                  formControlName="yrExp">
                  <div class="text-danger"*ngIf="(f['yrExp'].touched || isSubmited ) && f['yrExp'].errors" >
                      <div *ngIf="f['yrExp'].errors['required']">Years Of Experience is required</div>
                  </div>
              </div>
          </div>
          <div class="col-4">
              <div class="form-group">
                  <label for="degree">Degree<span>*</span></label>
                  <ng-select #ForceAllocationOfficers  [items]="qualification" [multiple]="true" [closeOnSelect]="true" [clearable]="true"
                  (clear)="resetTeantFilters();" bindLabel="item" bindValue="item"
                  placeholder="Select Language" (change)="selectQualification($event)">
                  <ng-options *ngFor="let item of qualification " [Value]="qualification">{{item}}
                  </ng-options>
                </ng-select>
                  <!-- <ng-multiselect-dropdown
                  formControlName="degree"
                  [settings]="dropdownDegreeSettings"
                  [data]="qualification"
                  [(ngModel)]="selectedDegreeList"
                  (onSelect)="onDereeSelection($event)"
                  (onDeSelect)="onDegreeDeSelect($event)"
                  (onSelectAll)="onSelectAll($event)"
                  (onDeSelectAll)="onDeSelectAll($event)">
                  </ng-multiselect-dropdown> -->
                  <div class="text-danger"*ngIf="(f['degree'].touched || isSubmited ) && f['degree'].errors" >
                      <div *ngIf="f['degree'].errors['required']">Degree is required</div>
                  </div>
              </div>
          </div>
      </div>
      <!-- <div class="submit-btn mt-3">
          <button type="button" class="w-130 btn-blue-border mr-20" (click)="closePopUp()">Cancel</button>
          <button type="button" class="w-130 btn-blue" (click)="submitFn()">Submit</button>
      </div> -->
  </form>
    <div class="modal-footer customModalFooter">
      <button type="button" class="btn danger_btn" (click)="modelClose()">Cancel</button>
      <button type="button" class="btn green_btn" (click)="submitForceAllocation()">Submit</button>
    </div>
  </div>
</div>